import { takeLatest, take, call, put } from 'redux-saga/effects';
import Api from 'api/auth';
import { setAPIInProgress, signUp } from 'store/actions/authActions';

function* SignUp({ payload: { userData, resolve, reject } }) {
  try {
    yield put({ type: setAPIInProgress.type, payload: true });
    const { data } = yield call(Api.signUp, { data: JSON.stringify(userData) });
    yield put({
      type: signUp.success,
      payload: {
        ...data,
      },
    });
    yield put({ type: setAPIInProgress.type, payload: false });
    if (resolve) {
      resolve();
    }
  } catch (err) {
    yield put({ type: setAPIInProgress.type, payload: false });
    yield put({
      type: signUp.failure,
      err,
    });
    if (reject) {
      reject();
    }
  }
}

export function* watchSignup() {
  yield takeLatest(signUp.type, SignUp);
  yield take(signUp.success);
}
